import { INTERNAL_PATHS } from "routes/paths";
import earnGcxCashImage from "assets/images/how-it-works/earn-gcx-cash.png";
import payInStoreImage from "assets/images/how-it-works/pay-in-store-online.png";
import saveEverywhereImage from "assets/images/how-it-works/save-everywhere.png";

const DEFAULT_ANCHOR_ACTION = {
  text: "SHOP NOW",
  route: INTERNAL_PATHS.BUY_GIFT_CARDS
};

export const SHOP_NOW_SECTIONS = [
  {
    id: 1,
    content: {
      title: "Save Everywhere",
      description:
        "Save up to 30% on discounted gift cards from 4,000+ brands on our marketplace. Combine them with store sales to save even more."
    },
    anchorAction: DEFAULT_ANCHOR_ACTION,
    imageUrl: saveEverywhereImage
  },
  {
    id: 2,
    content: {
      title: "Earn GCX Cash",
      description:
        "Earn GCX Cash instantly for over 150 retail partners when you buy face-value cards. Enter the exact amount you’d like to pay, and we’ll apply your earnings on future orders."
    },
    anchorAction: DEFAULT_ANCHOR_ACTION,
    imageUrl: earnGcxCashImage,
    reverse: true
  },
  {
    id: 3,
    content: {
      title: "Pay In Store or Online",
      description:
        "Most cards are delivered electronically within minutes. Log into your GCX account online or download the GCX app to access and redeem your cards."
    },
    anchorAction: DEFAULT_ANCHOR_ACTION,
    imageUrl: payInStoreImage
  }
];
